<template>
  <div>
    <b-form-input
        v-model="query"
        type="text"
        placeholder="Введите текст..."
        @input="onInput"
        autocomplete="off"
    />
    <b-list-group v-if="shouldShowSuggestions">
      <b-list-group-item
          v-for="(item, index) in filteredMakes"
          :key="index"
          @click="selectSuggestion(item.make)"
          class="suggestion-item"
      >
        {{ item.make }} (Использовано: {{ item.count }})
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: '',
      shouldShowSuggestions: false, // добавляем состояние для управления показом списка
    };
  },
  computed: {
    filteredMakes() {
      if (this.query.length < 1) {
        return [];
      }

      return this.$store.getters.getMakes.filter(item =>
          item.make.toLowerCase().startsWith(this.query.toLowerCase()) &&
          item.make.toLowerCase() !== this.query.toLowerCase() // Исключаем точное совпадение
      ).sort((a, b) => b.count - a.count); // Сортируем по убыванию count
    },
  },
  methods: {
    onInput() {
      // Фильтрация выполняется через вычисляемое свойство
      if (this.query.length > 0) {
        this.shouldShowSuggestions = true;
      } else {
        this.shouldShowSuggestions = false;
      }
    },
    selectSuggestion(suggestion) {
      this.query = suggestion;
      this.shouldShowSuggestions = false; // скрываем список после выбора
      this.$emit('input', this.query);
    },
  },
};
</script>

<style scoped>
.suggestion-item {
  cursor: pointer;
}
</style>
